import {
    SET_PROCESS_STARTED,
    SET_AUTHORIZING,
    SET_AUTHORIZATION_FAILED,
    SET_REFRESH,
    SET_STARTING,
    SET_TEXTS,
} from './constants'

const initialState = {
    processStarted: '',
    authorizing: '',
    authorizationFailed: '',
    refresh: '',
    starting: '',
}

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case SET_PROCESS_STARTED: {
            return {
                ...state,
                processStarted: action.payload,
            }
        }

        case SET_AUTHORIZING: {
            return {
                ...state,
                authorizing: action.payload,
            }
        }

        case SET_AUTHORIZATION_FAILED: {
            return {
                ...state,
                authorizationFailed: action.payload,
            }
        }

        case SET_REFRESH: {
            return {
                ...state,
                refresh: action.payload,
            }
        }

        case SET_STARTING: {
            return {
                ...state,
                starting: action.payload,
            }
        }

        case SET_TEXTS: {
            return action.payload
        }

        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/features/LaunchProgressBar/data/texts/reducer.js